
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import axios from '../Axiosinstance';
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Box,
    TablePagination, Card, CardContent,
    Paper,
    Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid, DialogContentText
} from '@mui/material';

import { Button, Modal, Spinner } from 'react-bootstrap';

import { toast, ToastContainer } from 'react-toastify';



const ViewDetailsModal = ({ studentid, onClose }) => {

    const [loading, setLoading] = useState(false);
    const [openViewDialog, setOpenViewDialog] = useState(false);
    const [studentDetails, setStudentDetails] = useState(null);
    const [scheduleData, setScheduleData] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState({
        workPermitSpass: null,
        passport: null,
        markSheet: [], // Initialize as an empty array
        profilePicture: null,
    });


    const handleCloseViewDialog = () => setOpenViewDialog(false);

    useEffect(() => {
        if (!studentid) return; // Do nothing if studentid is not set

        const fetchStudentData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`/registrationadvances/${studentid}`);
                const { scheduleDate, markSheet, batch, ...studentData } = response.data;

                // Copy batch details to studentData
                const updatedStudentData = { ...studentData, batch };

                // Create a map for moduleDetails based on id
                const moduleDetailsMap = {};
                batch?.moduleDetails.forEach(module => {
                    moduleDetailsMap[module.id] = module.moduleName;
                });

                // Map the module details to the schedule data based on startModulus
                const updatedScheduleData = scheduleDate.map(schedule => {
                    const moduleDetail = batch?.moduleDetails.find(
                        module => module.id === schedule.startModulus
                    );
                    return {
                        ...schedule,
                        moduleDetail: moduleDetail ? moduleDetail.moduleName : 'N/A'
                    };
                });

                // Update student details and schedule data
                setStudentDetails({ ...updatedStudentData, markSheet });
                setScheduleData(updatedScheduleData);

                // Set uploaded files including markSheet
                setUploadedFiles({
                    workPermitSpass: studentData.workPermitSpass,
                    passport: studentData.passport,
                    markSheet: markSheet, // Set markSheet
                    profilePicture: studentData.profilePicture,
                });

                setOpenViewDialog(true);
            } catch (error) {
                console.error('Error fetching student details:', error);
                toast.error('Error fetching student details');
            } finally {
                setLoading(false);
            }
        };

        fetchStudentData();
    }, [studentid]);


    const markSheets = studentDetails?.markSheet;
    const institutionDetails = studentDetails?.institutionDetails || [];

    // Filter out any keys that contain "Progress" or "Status"
    const filteredMarkSheets = markSheets
        ? Object.entries(markSheets).filter(([key]) => !key.includes('Progress') && !key.includes('Status'))
        : [];



    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <Dialog fullScreen onClose={handleCloseViewDialog}>
            <DialogTitle>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    {studentDetails?.name || '-'}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3}>
                    <Paper elevation={3} style={{ padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px', maxWidth: '1400px', margin: '62px' }}>
                        <Typography variant="h6" gutterBottom style={{ marginBottom: '16px', color: '#333', borderBottom: '2px solid #ccc', paddingBottom: '8px', fontWeight: 'bolder' }}>
                            Basic Personal Information
                        </Typography>
                        {studentDetails ? (
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Name:</strong> {studentDetails.name || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Phone No:</strong> {studentDetails.phone || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Date of Birth:</strong> {studentDetails.dob || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Gender:</strong> {studentDetails.gender || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Passport No:</strong> {studentDetails.passportNo || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Email:</strong> {studentDetails.email || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Type:</strong> {studentDetails?.type || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Course:</strong> {studentDetails?.batch?.course || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Country of Birth:</strong> {studentDetails?.countryBirth || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <strong>Know About Program:</strong> {studentDetails?.knowAboutProgram || '-'}
                                        {(studentDetails?.knowAboutProgram === 'referral' || studentDetails?.knowAboutProgram === 'other') && (
                                            <>
                                                {' - '}
                                                {studentDetails?.knowAboutProgram === 'referral'
                                                    ? studentDetails?.referalfriend || '-'
                                                    : studentDetails?.otherDetails || '-'}
                                            </>
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>Date:</strong> {formatDate(studentDetails?.date) || '-'}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Office): </strong>{studentDetails?.phoneOffice || '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Home): </strong>{studentDetails?.phoneHome || '-'}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography ><FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Office):</strong> {studentDetails?.addressOffice || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography ><FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Home):</strong> {studentDetails?.addressHome || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography ><strong><FontAwesomeIcon icon={faPhone} /> Emergency Contact:</strong> {studentDetails?.emergencyPhone || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography><strong>Name:</strong> {studentDetails?.emergencyName || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography ><strong>Relation:</strong> {studentDetails?.emergencyRelation || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography ><strong>Phone:</strong> {studentDetails?.emergencyPhone || '-'}</Typography>
                                </Grid>
                            </Grid>
                        ) : (
                            <Typography style={{ marginTop: '16px', color: 'red', textAlign: 'center' }}>No information available.</Typography>
                        )}
                    </Paper>
                    <Table style={{ maxWidth: "100%", marginLeft: "50px" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Document Name</TableCell>
                                <TableCell>View</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {uploadedFiles.workPermitSpass && (
                                <TableRow key="workPermitSpass">
                                    <TableCell>NRIC/WorkPermit</TableCell>
                                    <TableCell>
                                        <Button onClick={() => window.open(uploadedFiles.workPermitSpass, '_blank')}>
                                            View
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )}
                            {uploadedFiles.passport && (
                                <TableRow key="passport">
                                    <TableCell>Passport</TableCell>
                                    <TableCell>
                                        <Button onClick={() => window.open(uploadedFiles.passport, '_blank')}>
                                            View
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )}
                            {uploadedFiles.markSheet?.map(([level, url], index) => (
                                <TableRow key={level}>
                                    <TableCell>{institutionDetails[index]?.institution || 'Unknown Institution'}</TableCell>
                                    <TableCell>
                                        <Button onClick={() => window.open(url, '_blank')}>
                                            View
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {uploadedFiles.markSheet?.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                                        <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No marksheets available
                                    </TableCell>
                                </TableRow>
                            )}
                            {uploadedFiles.profilePicture && (
                                <TableRow key="profilePicture">
                                    <TableCell>Profile Picture</TableCell>
                                    <TableCell>
                                        <Button onClick={() => window.open(uploadedFiles.profilePicture, '_blank')}>
                                            View
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Grid item xs={6}>
                        <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }} >Institution Details</Typography>
                            {studentDetails?.institutionDetails && studentDetails?.institutionDetails.length > 0 ? (
                                <TableContainer>
                                    <Table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Institution</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Year</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Full Time/Part Time</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Qualifications Achieved</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {studentDetails.institutionDetails.map((detail, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{detail.institution || '-'}</TableCell>
                                                    <TableCell>{detail.year || '-'}</TableCell>
                                                    <TableCell>{detail.fullTimePartTime || '-'}</TableCell>
                                                    <TableCell>{detail.qualificationsAchieved || '-'}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                <Typography>No institution details available.</Typography>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseViewDialog} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewDetailsModal;
